import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { UpdateBatchBody } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

export const updateBatch = createApiThunk<void, UpdateBatchBody>(
  "batches/updateBatch",
  async (body, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.updateBatch(body);
  },
);

export const resetUpdateBatch = createAction("batches/resetUpdateBatch");
